import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { installWriteNet } from './lib/writeGuard';
import { registerSW } from 'virtual:pwa-register';
import { App } from './app/App';
import { useAppStore } from './app/store';
import { flushChanges, trackChanges } from './db/changes';
import { stripStoredTitles } from './db/repos/dig';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/base.css';

// SPEC F8: note changes to your data for the backup reminder. The hooks go in before the first read.
trackChanges();
document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') void flushChanges().catch(() => undefined); });
// Restore settings and where you left off before the first paint, so the
// first screen is the right one (DESIGN_SYSTEM §5: continuity).
await useAppStore.getState().hydrate();
// Marks and records written by older versions kept YouTube titles; the 30-day rule means they must go (no await: nothing waits on it)
void stripStoredTitles().catch(() => undefined);
// v0.5.1: perc samples from older versions get the kind their name says (idempotent; never touches a kind you picked).
// Imported lazily so the samples repo and the hint tables stay out of the initial JS.
void import('./db/repos/samples').then((m) => m.backfillPercKinds()).catch(() => undefined);

const root = document.getElementById('root');
if (!root) throw new Error('index.html has no #root');

installWriteNet();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// SPEC F8: the service worker's waiting state becomes an "Update ready" toast.
const updateSW = registerSW({
  onNeedRefresh() {
    useAppStore.getState().showToast({
      message: 'Update ready',
      action: { label: 'Reload', run: () => void updateSW(true) },
      duration: Infinity,
    });
  },
});
